import './ContactUs.css';
import {Component} from "react";
import Top from "./Top";
import Footer from "./Footer";

class aboutUs extends Component {
    render() {
        return (
            <div className="about-us">
                <Top/>
                <div className="about-us-model-box section-background-gray">
                    <div className="about-us-big-word">Contact Us</div>
                </div>

                <div className={'contact-us-detail-container'}>
                    <div className={'contact-us-detail-wrapper'}>
                        <div className={'contact-us-leave-msg-container'}>
                            <div className={'contact-us-leave-msg-title'}>LET'S GET IN TOUCH</div>
                            <input className={'contact-us-input'} type="text" placeholder={'Your Name'}/>
                            <input className={'contact-us-input'} type="text" placeholder={'Email'}/>
                            <textarea className={'contact-us-input'} placeholder={'Message'}/>
                            <div className={'contact-us-submit-msg'}>Submit</div>
                        </div>
                        <div className={'contact-us-info-container'}>
                            <div className={'contact-us-info-title'}>CONTACT INFO</div>
                            <div className={'contact-us-info-sub-title'}>Address</div>
                            <div className={'contact-us-info-content'}>1771 Robson Street
                                Vancouver, BC, Canada, V6G 3B7</div>

                            <div className={'contact-us-info-sub-title contact-us-info-sub-title-margin'}>Email Us</div>
                            <div className={'contact-us-info-content'}>contact@nebulabinary.com</div>
                            <div className={'contact-us-info-sub-title contact-us-info-sub-title-margin'}>Call Us</div>
                            <div className={'contact-us-info-content'}>(423) 451 6288</div>

                        </div>
                    </div>
                </div>
                <div>
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d19653.164013370304!2d-123.13231517010234!3d49.281599845146886!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54867180452591c5%3A0xdd81e52c7123ef28!2zMTc3MSBSb2Jzb24gU3QsIFZhbmNvdXZlciwgQkMgVjZHIDFDOeWKoOaLv-Wkpw!5e0!3m2!1szh-CN!2shk!4v1678197894756!5m2!1szh-CN!2shk"
                        width="100%" height="450" style={{border: '0'}} allowFullScreen="" loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"></iframe>
                </div>

                {/*<div className="about-us-model-box">*/}
                {/*    <div className="about-us-model-box-title">Our Company</div>*/}
                {/*    <div className="about-us-model-box-paragraph">Nebula Binary Software Technology Inc., trading as*/}
                {/*        https://www.nebulabinary.com (“Us”, “We” or “Our”), a company registered in British Columbia (Business Number*/}
                {/*        #746630144BC0001) whose registered*/}
                {/*        address is at: 1771 Robson Street, Vancouver, BC, Canada, V6G 3B7.*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<div className='about-us-model-box section-background-gray'>*/}
                {/*    <div className="about-us-model-box-title">Terms & Conditions</div>*/}
                {/*    <div className="about-us-model-box-paragraph">*/}
                {/*        <div>The products and services offered by Us through this https://www.nebulabinary.com website*/}
                {/*            (the “Site”) are subject to the Website Terms of Use and Trading Terms set out below which*/}
                {/*            together form*/}
                {/*            the terms and conditions (“Terms and Conditions”). By using the Site, you accept, without*/}
                {/*            limitation or qualification, these Terms and Conditions. If you do not agree to these Terms*/}
                {/*            and Conditions, please do not use this Site.*/}
                {/*        </div>*/}
                {/*        <br/>*/}
                {/*        <div>We reserve the right to update the Terms and Conditions at any time. When We do so, We will*/}
                {/*            provide access to the new Terms and Conditions on the Site home page. The new Terms and*/}
                {/*            Conditions will take effect immediately and will govern all transactions with Us through the*/}
                {/*            Site. If you do not agree with the new version of the Terms and Conditions, you must cease*/}
                {/*            to use the Site.*/}
                {/*        </div>*/}
                {/*        <br/>*/}
                {/*        <div>Privacy and Data Protection We are committed to protecting your privacy. Please also see*/}
                {/*            our privacy policy for further information on how we handle your personal information and*/}
                {/*            who we share it with.*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<div className='about-us-model-box'>*/}
                {/*    <div className="about-us-model-box-title">Privacy Policy</div>*/}
                {/*    <div className="about-us-model-box-paragraph">*/}
                {/*        <div className="about-us-paragraph-div">Nebula Binary Software Technology Inc.*/}
                {/*            (Business Number #746630144BC0001) is the controller responsible for your personal*/}
                {/*            data (collectively referred to as the “Company”, “we”, “us” or “our” in this privacy*/}
                {/*            policy).*/}
                {/*        </div>*/}
                {/*        <br/>*/}
                {/*        <div className="about-us-paragraph-div">If you have any questions relating to our*/}
                {/*            use of your data or this privacy policy,*/}
                {/*            including any requests to exercise your legal rights, please contact our data protection*/}
                {/*            team using the details set out below:*/}
                {/*        </div>*/}
                {/*        <br/>*/}
                {/*        <div className="about-us-paragraph-div">Email: dataprotect@nebulabinary.com*/}
                {/*        </div>*/}
                {/*        <br/>*/}
                {/*        <div className="about-us-paragraph-div">*/}
                {/*            Postal address: 1771 Robson Street, Vancouver, BC, Canada, V6G 3B7*/}
                {/*        </div>*/}
                {/*        <br/>*/}
                {/*        <div className="about-us-paragraph-div">*/}
                {/*            You have the right to make a complaint at any time to the relevant supervisory authority. We*/}
                {/*            would, however, appreciate the chance to deal with your concerns before you approach the ICO*/}
                {/*            so please contact us in the first instance.*/}
                {/*        </div>*/}
                {/*        <br/>*/}
                {/*        <div className="about-us-paragraph-div-bold section-content-highlight">*/}
                {/*            CHANGES TO THE PRIVACY POLICY AND YOUR DUTY TO INFORM US OF CHANGES*/}
                {/*        </div>*/}
                {/*        <br/>*/}
                {/*        <div className="about-us-paragraph-div">*/}
                {/*            This policy was last updated on the date shown at the top of the document. We reserve the*/}
                {/*            right to make further changes to this policy from time to time. We will always notify you in*/}
                {/*            advance of any changes that involve a new use of your data that may not be compatible with*/}
                {/*            the purpose for which we originally collected them.*/}
                {/*        </div>*/}
                {/*        <br/>*/}
                {/*        <div className="about-us-paragraph-div">*/}
                {/*            It is important that the personal data we hold about you is accurate and current so please*/}
                {/*            keep us informed if your personal data changes during your relationship with us.*/}
                {/*        </div>*/}
                {/*        <br/>*/}
                {/*        <div className="about-us-paragraph-div-bold section-content-highlight">*/}
                {/*            THIRD-PARTY LINKS*/}
                {/*        </div>*/}
                {/*        <br/>*/}
                {/*        <div className="about-us-paragraph-div">*/}
                {/*            Our websites, https://www.nebulabinary.com and others we may operate from time to time may*/}
                {/*            include links*/}
                {/*            to third-party websites, plug-ins and applications.*/}
                {/*        </div>*/}
                {/*        <br/>*/}
                {/*        <div className="about-us-paragraph-div">*/}
                {/*            Clicking on those links or enabling those connections may allow third parties to collect or*/}
                {/*            share data about you. We do not control these third-party websites and are not responsible*/}
                {/*            for their privacy statements. When you leave our website, we encourage you to read the*/}
                {/*            privacy policy of every website you visit.*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
                <Footer/>
            </div>
        );
    }
}

export default aboutUs